<script setup lang="ts">
import { useClassStore, useSignalRStore } from '../../stores'
import { computed } from 'vue'
import LockIcon from '../../assets/icons/lock.svg'
import UnlockIcon from '../../assets/icons/lock-open.svg'
import Switch from '../Form/Switch.vue'

const classStore = useClassStore()
const signalr = useSignalRStore()

const enabled = computed({
    get: () => classStore.isLockedScreen,
    set: (value: boolean) => {
        signalr.lockScreen(value)
    },
})

// Map icon
const lockIconMap = {
    unlock: UnlockIcon,
    lock: LockIcon,
}
</script>

<template>
    <Switch v-model="enabled" color="lime">
        <template #label>
            <div class="flex items-center gap-1">
                <component :is="lockIconMap[enabled ? 'lock' : 'unlock']" class="size-6 transition-transform duration-200" />
            </div>
        </template>
    </Switch>
</template>